// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"0":"00c67d75","99":"f62c4f9b","216":"97525f5a","404":"a5c6d190","486":"a50deb7d","521":"64327aec","609":"74870f7d","637":"35dbb775","681":"8815bd5a","692":"d060d42c","695":"258c923e","719":"9eedb652","731":"b22d98d4","849":"c9e69ee3","970":"0cb3623a","997":"b2239e1c"}[chunkId] + ".chunk.js";
};